<template>
  <div
    id="map"
    class="map"
  >
    <div class="map__image">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 650 650"
      >
        <g>
          <path
            v-for="dep in departments"
            :id="dep.id"
            :key="dep.id"
            :class="{active:state.selected_region === dep}"
            :title="dep.title"
            :d="dep.d"
            @click="setData('selected_region',dep)"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "Map",
  props: {
    departments: {
      type: Array,
      required: true,
    }
  },
}
</script>